import React, { useState } from 'react';
import { AttachmentIcon } from 'ui-component/custom-icons/icons';
import PermissionAllowed from 'ui-component/permissions/PermissionAllowed';
import StatusBadge from 'ui-component/StatusBadge';
import { CommonDateOnlyFormat } from 'helpers/common.helper';
import { PiInfoFill } from 'react-icons/pi';
import { FaTimes } from 'react-icons/fa';
import moment from 'moment';
import DeleteConfirmation from 'ui-component/confirmation-dialogs/deleteConfirmation/DeleteConfirmation';
import toast from 'react-hot-toast';
import useIsMobile from 'utils/isMobileUtils';
import ActionConfirmationModal from 'ui-component/confirmation-dialogs/actionConfirmationModal/ActionConfirmationModal';


const PicklistShipmentComponent = ({ details, handleCancelShipment, handleDeleteShipment, handleReloadShipment }) => {

    const [data, setData] = useState([]);
    const [showRemoveCharges, setShowRemoveCharges] = useState(false)
    const [selectedShipmentCharge, setSelectedShipmentCharge] = useState(null);
    const [selectedShipmentIndex, setSelectedShipmentIndex] = useState(null);
	const [selectedShipmentChargeIndex, setSelectedShipmentChargeIndex] = useState(null);
	const [selectedShipmentDetails, setSelectedShipmentDetails] = useState(null);
	const [showDeleteShipmentPopup, setShowDeleteShipmentPopup] = useState(false);
	const [isLoading, setIsLoading] = useState(false);

    const removingChargesMessage = `Removing this has the following consequence:
                                        <div class="mt15">
                                            <ul>
                                                <li class="text-left">Charges will be removed from shipment details.</li>
                                                <li class="text-left">Charges cannot be recovered.</li>
                                            </ul>
                                        </div>`;


    const handleClose = () => {
        setShowRemoveCharges(false);

        setSelectedShipmentCharge(null)
        setSelectedShipmentChargeIndex(null)
        setSelectedShipmentIndex(null)
    }


    const handleRemoveCharges = () => {

        toast.promise(
            api
                .deleteShipmentCharges(selectedShipmentCharge)
                .then(
                    (res) => {
                        if (res.status) {
                                                
                            const updatedDetails = [...details];
                            
                            if (updatedDetails[selectedShipmentIndex] && Array.isArray(updatedDetails[selectedShipmentIndex].charges)) {
                                updatedDetails[selectedShipmentIndex].charges = updatedDetails[selectedShipmentIndex].charges.filter((_, idx) => idx !== selectedShipmentChargeIndex);
                            }
                            handleClose()
                        }
    
                        return res?.status ? res : null;
                    },
                    () => { }
                ),
            {
                loading: 'Removing charges...',
                success: (data) => `${data.message}`,
                error: <b>Failed to remove charges</b>
            }
        );
    }
    const deleteShipment = () => {
        setIsLoading(true);
        toast.promise(
            api
                .deleteShipmentFromPicklist(selectedShipmentDetails)
                .then(
                    (res) => {
						setIsLoading(false);
						setShowDeleteShipmentPopup(false);
						handleReloadShipment()

                        return res?.status ? res : null;
                    },
                    () => { }
                ),
            {
                loading: 'Removing charges...',
                success: (data) => `${data.message}`,
                error: <b>Failed to remove charges</b>
            }
        );
    }

    const isMobile = useIsMobile();
    return (
			<>
				{!isMobile ? (
					<div className="productsTable estlist" style={{ padding: '20px 6px' }}>
						<div className="table-responsive-xl tableData">
							<div>
								<h2 style={{ display: 'flex', alignItems: 'center', gap: '5px', fontSize: '18px', fontWeight: '600' }}>Shipments</h2>
							</div>
							<div className="row mt10">
								<div className="col-lg-2 font500">Provider</div>
								<div className="col-lg-3 font500">Tracking No</div>
								<div className="col-lg-1 font500">Qty</div>
								<div className="col-lg-2 font500">Attachment</div>
								<div className="col-lg-2 font500">Status</div>
								<div className="col-lg-2 font500">Shipment Date</div>
							</div>
							<hr className="mt5" />

							{details?.map((item, index) => (
								<>
									<div className="row hover-row">
										<div className="col-lg-2 align-middle">{item?.shipping_company?.name}</div>
										<div className="col-lg-3 align-middle">
											<a href={item?.tracking_url} target="_blank" rel="noreferrer">
												{item?.tracking_no}
											</a>
										</div>
										<div className="col-lg-1 align-middle">{item?.total_quantity}</div>
										<div className="col-lg-2 align-middle">
											{
												item?.attachment?.length > 0 ? (
													item?.attachment?.map((attachment, attachmentIndex) => (
														<div>

															<a href={attachment?.attachment_url} target="_blank" rel="noreferrer">
																<AttachmentIcon width="15px" height="15px" /> Attachment
															</a>
														</div>
													))
												) : (
													<span className="text-gray-600">
														No Attachment
													</span>
												)
											}
										</div>
										<div className="col-lg-2 align-middle">
											<div style={{ width: '90px' }}>
												<StatusBadge itemStatus={item?.status?.name} />
											</div>
										</div>
										<div className="col-lg-2 align-middle">{moment(item?.created_at).format(CommonDateOnlyFormat)}</div>
										<div className="hover-button-container-lg" style={{ marginTop: '0px' }}>
											<div>
												<div className="hover-button">
													<PermissionAllowed permissions={['Delete Operations']}>
														<div
															className="btn btn-danger  btn-sm cursor-pointer"
															style={{ marginLeft: '8px' }}
															onClick={() => {
																setSelectedShipmentDetails(item?.id);
																setShowDeleteShipmentPopup(true)
															}}
														>
															<div style={{ margin: 'auto 5px auto 3px' }}>
																<FaTimes style={{ marginTop: '-1px', marginRight: '3px' }} />
																Delete
															</div>
														</div>
													</PermissionAllowed>
												</div>
											</div>
										</div>
									</div>
									<hr />
								</>
							))}
						</div>
					</div>
				) : (
					<div className="m-0 p-3 p-xl-4 w-100 new-card">
						<div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
							<h2 style={{ display: 'flex', alignItems: 'center', gap: '5px', fontSize: '18px', fontWeight: '600' }}>Shipments</h2>

							{details?.map((item, index) => (
								<div
									key={index}
									style={{ paddingTop: 10, paddingBottom: 10, borderBottom: index < details.length - 1 ? '1px solid #eee' : 'none' }}
								>
									<div style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
										<div>Shipment Provider</div>
										<div style={{ fontWeight: 500 }}>{item?.shipping_company?.name}</div>
									</div>
									<div style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
										<div>Tracking Number</div>
										<div style={{ fontWeight: 500 }}>{item?.tracking_no}</div>
									</div>
									<div style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
										<div>Quantity</div>
										<div style={{ fontWeight: 500 }}>{item?.total_quantity}</div>
									</div>
									<div style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
										<div>Status</div>
										<div style={{ fontWeight: 500 }}>{item?.status?.name}</div>
									</div>

									<div style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
										<div>Shipment Date</div>
										<div style={{ fontWeight: 500 }}>{moment(item?.created_at).format(CommonDateOnlyFormat)}</div>
									</div>
									<div style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
										<div>Attachments</div>
										<div style={{ fontWeight: 500 }}>
											{
												item?.attachment?.length > 0 ? (
													item?.attachment?.map((attachment, attachmentIndex) => (
														<div>

															<a href={attachment?.attachment_url} target="_blank" rel="noreferrer">
																<AttachmentIcon width="15px" height="15px" /> Attachment
															</a>
														</div>
													))
												) : (
													<span className="text-gray-600">
														No Attachment
													</span>
												)
											}
										</div>
									</div>
								</div>
							))}
						</div>
					</div>
				)}
				<div style={{ height: 10 }} className="show-on-mobile"></div>

				{!isMobile ? (
					<div className="productsTable estlist" style={{ padding: '20px 6px' }}>
						<div className="table-responsive-xl tableData">
							<div>
								<h2 style={{ display: 'flex', alignItems: 'center', gap: '5px', fontSize: '18px', fontWeight: '600' }}>Shipment Charges</h2>
							</div>
							<div className="row mt10">
								<div className="col-2 font500">Amount</div>
								<div className="col-10 font500">Details</div>
							</div>
							<hr className="mt5" />

							{details?.map((item, index) => (
								item?.charges?.length > 0 ? (
									item?.charges?.map((charge, chargeIndex) => (
										<>
											<div className="row hover-row" key={chargeIndex}>
												<div className="col-2">{`${charge?.currency_code} ${charge?.amount}`}</div>
												<div className="col-10">{charge?.description}</div>

												<div className="hover-button-container-lg" style={{ marginTop: '0px' }}>
													<div>
														<div className="hover-button">
															<PermissionAllowed permissions={['Delete Operations']}>
																<div
																	className="btn btn-danger btn-outlined-danger white-var btn-sm cursor-pointer"
																	style={{ marginLeft: '8px' }}
																	onClick={() => {
																		setSelectedShipmentCharge(charge?.id);
																		setSelectedShipmentChargeIndex(chargeIndex);
																		setSelectedShipmentIndex(index);

																		setShowRemoveCharges(true);
																	}}
																>
																	<div style={{ margin: 'auto 5px auto 3px' }}>
																		<FaTimes style={{ marginTop: '-1px', marginRight: '3px' }} />
																		Remove
																	</div>
																</div>
															</PermissionAllowed>
														</div>
													</div>
												</div>
											</div>
											<hr />
										</>
									))
								) : (
									<div className="row">
										<div className="col-12 text-gray-600 fw-600">No Charges</div>
									</div>
								)
							))}
						</div>
					</div>
				) : (
					<div className="m-0 p-3 p-xl-4 w-100 new-card">
						<div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
							<h2 style={{ display: 'flex', alignItems: 'center', gap: '5px', fontSize: '18px', fontWeight: '600' }}>Shipment Charges</h2>
							{details?.map((item, index) => (
								<div
									key={index}
									style={{ paddingTop: 10, paddingBottom: 10, borderBottom: index < details.length - 1 ? '1px solid #eee' : 'none' }}
								>
									{item?.charges?.length > 0 ? (
										item?.charges?.map((charge, chargeIndex) => (
											<div
												key={chargeIndex}
												style={{ display: 'flex', width: '100%', justifyContent: 'space-between', marginBottom: '10px' }}
											>
												<div>{charge?.description}</div>
												<div>{`${charge?.currency_code} ${charge?.amount}`}</div>
											</div>
										))
									) : (
										<div>No Charges</div>
									)}
								</div>
							))}
						</div>
					</div>
				)}

				{showRemoveCharges && (
					<DeleteConfirmation
						show={showRemoveCharges}
						handleClose={handleClose}
						handleDelete={handleRemoveCharges}
						title="Are you sure?"
						message={removingChargesMessage}
						customDeleteButtonText={'Yes, Remove this charges'}
					/>
				)}

			
				{showDeleteShipmentPopup && (
					<ActionConfirmationModal
						show={showDeleteShipmentPopup}
						message={'Are you sure you want to delete this shipment?'}
						title={'Confirmation'}
						customConfirmText={'Delete'}
						customCancelText={'Cancel'}
						customIcon={<PiInfoFill />}
						handleConfirm={() => {
							deleteShipment()
						}}
						handleClose={() => {
							setShowDeleteShipmentPopup(false);
						}}
						hasIsLoading={true}
						isLoading={isLoading}
					/>
				)}
			</>
		);
};

export default PicklistShipmentComponent;
